import { ADMINISTRATOR, AGENCY_CLIENT, CLIENT, CUSTOMER_SUCCESS, PARTNER_CLIENT } from '../../../shared/services/user.service';
import { MenuItem } from './menu-item';

/**
 * Chave do item na config da etiqueta "Novo" (CU-17tm466mg60): a declarada no
 * item ou, sem ela, o `path` sem a barra inicial. Quais itens mostram a etiqueta,
 * e até quando, vem da API (`MenuNewBadgeService`), não deste catálogo.
 */
export function menuItemKey(item: MenuItem): string {
  return item.newBadgeKey || (item.path || '').replace(/^\//, '');
}

export const menuItems: MenuItem[] = [
  {
    path: '/dashboard',
    text: 'Dashboard',
    icon: 'fa-tachometer',
    simulated: true,
    global: true,
    profiles: [
      ADMINISTRATOR,
      AGENCY_CLIENT,
      CLIENT,
      PARTNER_CLIENT,
      CUSTOMER_SUCCESS
    ]
  },
  {
    // Logo abaixo do Dashboard (pedido do Bruno, 28/09/2026): o saldo é a
    // primeira coisa que o cliente procura depois do resumo. Ícone diferente do
    // `fa-money` da Recarga de propósito — duas entradas com o mesmo ícone no
    // mesmo menu não se distinguem.
    path: '/wallet',
    text: 'Minha Carteira',
    icon: 'fa-credit-card',
    simulated: true,
    global: true,
    profiles: [
      ADMINISTRATOR,
      AGENCY_CLIENT,
      CLIENT,
      PARTNER_CLIENT,
      CUSTOMER_SUCCESS,
    ]
  },
  {
    path: '',
    text: 'WhatsApp',
    // Grupo sem rota própria: a chave da etiqueta "Novo" é declarada (CU-17tm466mg60).
    newBadgeKey: 'whatsapp',
    icon: 'fa-whatsapp',
    simulated: true,
    global: true,
    // Compartilhado: quem tem IA continua vendo, quem só tem WhatsApp passa a ver.
    requiresAiOrWhatsapp: true,
    profiles: [
      ADMINISTRATOR,
      AGENCY_CLIENT,
      CLIENT,
      PARTNER_CLIENT,
      CUSTOMER_SUCCESS
    ],
    children: [
      {
        path: '/whatsapp-integration',
        text: 'Integrações WhatsApp',
        icon: 'fa-whatsapp',
        simulated: true,
        global: true,
        profiles: [
          ADMINISTRATOR,
          AGENCY_CLIENT,
          CLIENT,
          PARTNER_CLIENT,
          CUSTOMER_SUCCESS
        ]
      },
      {
        path: '/conversations',
        text: 'Conversas',
        newBadgeKey: 'whatsapp-conversations',
        icon: 'fa-comments',
        simulated: true,
        global: true,
        profiles: [
          ADMINISTRATOR,
          AGENCY_CLIENT,
          CLIENT,
          PARTNER_CLIENT,
          CUSTOMER_SUCCESS
        ]
      }
    ]
  },
  {
    path: '',
    text: 'IA',
    // Mesma chave do grupo IA da linha PROD (lá ele tem o path `/ia`).
    newBadgeKey: 'ia',
    icon: 'fa-magic',
    simulated: true,
    global: true,
    requiresAi: true,
    profiles: [
      ADMINISTRATOR,
      AGENCY_CLIENT,
      CLIENT,
      PARTNER_CLIENT,
      CUSTOMER_SUCCESS
    ],
    children: [
      {
        path: '/playground-ia',
        text: 'Meus Agentes',
        newBadgeKey: 'ai-agents',
        icon: 'fa-robot',
        simulated: true,
        global: true,
        profiles: [
          ADMINISTRATOR,
          AGENCY_CLIENT,
          CLIENT,
          PARTNER_CLIENT,
          CUSTOMER_SUCCESS
        ]
      }
    ]
  },
  {
    path: '/provider',
    text: 'Provedores',
    icon: 'fa-server',
    simulated: true,
    global: true,
    profiles: [
       ADMINISTRATOR
    ]
  },
  {
    path: '/partner',
    text: 'Parceiros',
    icon: 'fa-handshake-o',
    simulated: true,
    profiles: [
      ADMINISTRATOR,
      AGENCY_CLIENT,
      PARTNER_CLIENT
    ]
  },
  {
    path: '/lists',
    text: 'Listas',
    icon: 'fa-list',
    simulated: true,
    global: true,
    profiles: [
      ADMINISTRATOR,
      AGENCY_CLIENT,
      CLIENT,
      PARTNER_CLIENT,
      CUSTOMER_SUCCESS
    ]
  },
  {
    path: '/campaigns',
    text: 'Automações',
    icon: 'fa-bolt',
    simulated: true,
    global: true,
    profiles: [
      ADMINISTRATOR,
      AGENCY_CLIENT,
      CLIENT,
      PARTNER_CLIENT,
      CUSTOMER_SUCCESS
    ]
  },
  {
    path: '/broadcasts',
    text: 'SMS Massivo',
    icon: 'fa-paper-plane-o',
    simulated: true,
    global: true,
    profiles: [
      ADMINISTRATOR,
      AGENCY_CLIENT,
      CLIENT,
      PARTNER_CLIENT,
      CUSTOMER_SUCCESS
    ]
  },
  {
    path: '/integration-sms',
    text: 'SMS via Integração',
    icon: 'fa-plug',
    simulated: true,
    global: true,
    requiresIntegrationSms: true,
    profiles: [
      ADMINISTRATOR,
      AGENCY_CLIENT,
      CLIENT,
      PARTNER_CLIENT,
      CUSTOMER_SUCCESS
    ]
  },
  // {
  //   path: '/broadcasts-whatsapp',
  //   text: 'Whatsapp Massivo',
  //   icon: 'fa-whatsapp',
  //   simulated: true,
  //   global: true,
  //   profiles: [
  //     ADMINISTRATOR,
  //     AGENCY_CLIENT,
  //     CLIENT,
  //     PARTNER_CLIENT,
  //     CUSTOMER_SUCCESS
  //   ]
  // },
  {
    path: '/ligacoes',
    text: 'Ligações',
    icon: 'fa-phone',
    simulated: true,
    global: true,
    profiles: [
      ADMINISTRATOR,
      AGENCY_CLIENT,
      CLIENT,
      PARTNER_CLIENT,
      CUSTOMER_SUCCESS
    ],
    children: [
      {
        path: '/call4u-audios',
        text: 'Áudios',
        icon: 'fa-microphone',
        simulated: true,
        global: true,
        profiles: [
          ADMINISTRATOR,
          AGENCY_CLIENT,
          CLIENT,
          PARTNER_CLIENT,
          CUSTOMER_SUCCESS
        ]
      },
      {
        path: '/broadcasts-call',
        text: 'Broadcasts',
        icon: 'fa-bullhorn',
        simulated: true,
        global: true,
        profiles: [
          ADMINISTRATOR,
          AGENCY_CLIENT,
          CLIENT,
          PARTNER_CLIENT,
          CUSTOMER_SUCCESS
        ]
      },
      {
        path: '/calls-report',
        text: 'Enviadas',
        icon: 'fa-list',
        simulated: true,
        global: true,
        profiles: [
          ADMINISTRATOR,
          AGENCY_CLIENT,
          CLIENT,
          PARTNER_CLIENT,
          CUSTOMER_SUCCESS
        ]
      },
      {
        path: '/ligacoes-metricas',
        text: 'Métricas',
        icon: 'fa-bar-chart',
        simulated: true,
        global: true,
        profiles: [
          ADMINISTRATOR,
          AGENCY_CLIENT,
          CLIENT,
          PARTNER_CLIENT,
          CUSTOMER_SUCCESS
        ]
      }
    ]
  },
  {
    // Canal RCS (task 17tm466frtx). Grupo próprio, e não filho do SMS Massivo:
    // antes de enviar o cliente precisa cadastrar e homologar a marca, e as duas
    // telas moram juntas. Só aparece com `rcs_enabled` na conta.
    path: '/rcs',
    text: 'RCS',
    icon: 'fa-commenting',
    badge: 'Novo',
    simulated: true,
    global: true,
    requiresRcs: true,
    profiles: [
      ADMINISTRATOR,
      AGENCY_CLIENT,
      CLIENT,
      PARTNER_CLIENT,
      CUSTOMER_SUCCESS
    ],
    children: [
      {
        path: '/rcs/agents',
        text: 'Agentes RCS',
        icon: 'fa-id-badge',
        simulated: true,
        global: true,
        dataTestid: 'menu-rcs-agents',
        profiles: [
          ADMINISTRATOR,
          AGENCY_CLIENT,
          CLIENT,
          PARTNER_CLIENT,
          CUSTOMER_SUCCESS
        ]
      },
      {
        path: '/rcs/broadcasts',
        text: 'Envio em massa RCS',
        icon: 'fa-paper-plane',
        simulated: true,
        global: true,
        dataTestid: 'menu-rcs-broadcasts',
        profiles: [
          ADMINISTRATOR,
          AGENCY_CLIENT,
          CLIENT,
          PARTNER_CLIENT,
          CUSTOMER_SUCCESS
        ]
      }
    ]
  },
  {
    path: '/fractionations',
    text: 'Fracionamentos',
    icon: 'fa-list-alt',
    simulated: true,
    global: true,
    profiles: [
      ADMINISTRATOR
    ]
  },
  {
    path: '/sms-validation',
    text: 'Validação SMS Massivo',
    icon: 'fa-bullhorn',
    simulated: true,
    global: true,
    profiles: [
      ADMINISTRATOR,
    ]
  },
  {
    path: '/messages-report',
    text: 'Mensagens',
    icon: 'fa-comment-o',
    simulated: true,
    global: true,
    profiles: [
      ADMINISTRATOR,
      AGENCY_CLIENT,
      CLIENT,
      PARTNER_CLIENT,
      CUSTOMER_SUCCESS
    ]
  },
  {
    path: '/lead-responses',
    text: 'Respostas',
    icon: 'fa-envelope-o',
    simulated: true,
    global: true,
    profiles: [
      ADMINISTRATOR,
      AGENCY_CLIENT,
      CLIENT,
      PARTNER_CLIENT,
      CUSTOMER_SUCCESS
    ]
  },
  {
    path: '/recharges',
    text: 'Recarga',
    icon: 'fa-money',
    simulated: true,
    global: true,
    profiles: [
      ADMINISTRATOR,
      AGENCY_CLIENT,
      CLIENT,
      PARTNER_CLIENT,
      CUSTOMER_SUCCESS,
    ]
  },
  {
    path: '/dominio-proprio',
    text: 'Domínio Próprio',
    icon: 'fa-link',
    badge: 'Novo',
    simulated: true,
    global: true,
    profiles: [
      ADMINISTRATOR,
      AGENCY_CLIENT,
      CLIENT,
      PARTNER_CLIENT,
      CUSTOMER_SUCCESS,
    ],
    children: [
      {
        path: '/dominio-proprio',
        text: 'Meu domínio',
        icon: 'fa-link',
        simulated: true,
        global: true,
        profiles: [
          ADMINISTRATOR,
          AGENCY_CLIENT,
          CLIENT,
          PARTNER_CLIENT,
          CUSTOMER_SUCCESS,
        ]
      },
      {
        path: '/dominio-proprio/precos',
        text: 'Configurações',
        icon: 'fa-sliders',
        simulated: true,
        global: true,
        profiles: [
          ADMINISTRATOR,
          CUSTOMER_SUCCESS,
        ]
      }
    ]
  },
  {
    path: '/users',
    text: 'Usuários',
    icon: 'fa-users',
    global: true,
    profiles: [
      ADMINISTRATOR,
      CUSTOMER_SUCCESS
    ]
  },
  {
    path: '/short-url-analysis',
    text: 'Analisar Sites',
    icon: 'fa-search',
    global: true,
    profiles: [
      ADMINISTRATOR
    ]
  },
  {
    path: '/broadcasts-filter',
    text: 'Analisar SMS Massivo',
    icon: 'fa-users',
    global: true,
    profiles: [
      ADMINISTRATOR
    ]
  },
  {
    path: '/partner-management',
    text: 'Agências',
    icon: 'fa-bank',
    global: true,
    profiles: [
      ADMINISTRATOR,
      CUSTOMER_SUCCESS
    ]
  },
  {
    path: '/relatorios',
    text: 'Relatórios',
    icon: 'fa-bar-chart',
    simulated: true,
    global: true,
    profiles: [
      ADMINISTRATOR,
      AGENCY_CLIENT,
      CLIENT,
      PARTNER_CLIENT,
      CUSTOMER_SUCCESS
    ],
    children: [
      {
        path: '/reports',
        text: 'Faturamento',
        icon: 'fa-file',
        global: true,
        profiles: [
          ADMINISTRATOR
        ]
      },
      {
        path: '/consumption-report',
        text: 'Consumo',
        icon: 'fa-file-text-o',
        simulated: true,
        global: true,
        profiles: [
          ADMINISTRATOR,
          CUSTOMER_SUCCESS
        ]
      },
      {
        path: '/provider-report',
        text: 'Provedores',
        icon: 'fa-server',
        global: true,
        profiles: [
          ADMINISTRATOR
        ]
      },
      {
        path: '/app-authentication-report',
        text: 'Acessos ao APP',
        icon: 'fa-mobile',
        global: true,
        profiles: [
          ADMINISTRATOR
        ]
      },
      {
        path: '/analytics',
        text: 'Outros',
        icon: 'fa-pie-chart',
        simulated: true,
        global: true,
        profiles: [
          ADMINISTRATOR,
          AGENCY_CLIENT,
          CLIENT,
          PARTNER_CLIENT,
          CUSTOMER_SUCCESS
        ]
      }
    ]
  },
  {
    path: '/financial',
    text: 'Fiscal',
    icon: 'fa-newspaper-o',
    global: true,
    profiles: [
      ADMINISTRATOR
    ]
  },
  {
    // Rodapé junto do Suporte: é o par "aprender / pedir ajuda" do protótipo, e
    // sair da lista principal tira da navegação de trabalho o único item que
    // não leva a uma tela de operação.
    path: '/help',
    text: 'Tutorial',
    icon: 'fa-graduation-cap',
    simulated: true,
    global: true,
    footer: true,
    profiles: [
      ADMINISTRATOR,
      AGENCY_CLIENT,
      CLIENT,
      PARTNER_CLIENT,
      CUSTOMER_SUCCESS
    ]
  }
];
